const GUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function isGuid(value: string): boolean {
  return GUID_REGEX.test(value);
}

// VITE_EXOBE_ID carries the Apps by Exobe app registration's client-ID GUID (the
// APPS_BY_EXOBE_ID deployment variable). A logical key such as `quickdial` is rejected:
// the infra deploy and the AppLauncher defaults use the same value verbatim, so a key
// would only resolve here and silently diverge everywhere else.
export function resolveLoginClientId(exobeId?: string, fallbackClientId?: string): string {
  const trimmedExobeId = exobeId?.trim();

  if (trimmedExobeId) {
    if (!isGuid(trimmedExobeId)) {
      throw new Error(
        `VITE_EXOBE_ID must be the Apps by Exobe client-ID GUID, not a key such as '${trimmedExobeId}'.`
      );
    }

    return trimmedExobeId;
  }

  const normalizedFallbackClientId = fallbackClientId?.trim();

  if (normalizedFallbackClientId) {
    if (!isGuid(normalizedFallbackClientId)) {
      throw new Error('Invalid VITE_AZURE_CLIENT_ID fallback for login client resolution.');
    }

    return normalizedFallbackClientId;
  }

  throw new Error('Missing login client ID configuration. Set VITE_EXOBE_ID or VITE_AZURE_CLIENT_ID.');
}
